import './TopNotification.scss';

export { default } from './TopNotification';
